import { REPLICATION_SIZE } from '../../../utils/constants';
import {
  auditFields,
  buildReplication,
  getMutationIsActive,
  getMutationNestedValue,
  getMutationNumberValue,
  getMutationStringValue
} from '../utils';

/**
 * Pull builder for blood product data
 *
 * @param {*} db RxDB database
 */
const pullBuilder = (doc) => {
  const where = doc ? `lastmodifiedAt_Gt: "${doc.lastmodifiedAt}"` : '';

  const query = `{
    listBloodProducts(
      limit: ${REPLICATION_SIZE}
      offset: 0
      ordering: "lastmodifiedAt,ASC"
      ${where}
    ) {
      results {
        id
        icode

        status
        volume
        expiryDate
        details

        bloodType
        bloodProductType { id name shelfLife shelfLifeUnit }
        facility { id name address }
        processing {
          id
          icode
          donation {
            id
            icode
            date
            length width volume
            bloodDonationCenter { id name address stockUnit { id name address } }
            donor { id donorCode fullName personName gender bloodType }
          }
        }

        ${auditFields}
      }
    }
  }`;

  return { query, variables: {} };
};

/**
 * Push builder for blood product data
 *
 * @param {*} db RxDB database
 */
const pushBuilder = (doc) => {
  const query = `
    mutation {
      upsertBloodProduct(
        input: {
          ${getMutationStringValue(doc, 'id')}
          ${getMutationStringValue(doc, 'status')}
          ${getMutationNumberValue(doc, 'volume')}
          ${getMutationStringValue(doc, 'expiryDate')}
          ${getMutationStringValue(doc, 'details')}

          ${getMutationNestedValue(doc, 'facility')}
          ${getMutationNestedValue(doc, 'processing')}

          ${getMutationIsActive(doc)}
        }
      ) {
        id
      }
    }
  `;

  return { query, variables: {} };
};

/**
 * Synchronize blood product data with GraphQL endpoint
 */
export const syncBloodProduct = (...args) => {
  return buildReplication(
    ...args,
    'bloodProduct',
    { pullBuilder, pullQuery: 'listBloodProducts' },
    { pushBuilder }
  );
};
